import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useCurrencyCalc } from "./useCurrencyCalc";

const useCanTaly = () => {
  const { data } = useGetCompanyQuery();
  const { currency } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });

  const canTaly =
    data?.result.preferences?.taly_integration &&
    currency.code.toLocaleLowerCase() === "kwd";
  return canTaly;
};

export default useCanTaly;
